const PASTED_IMAGE_MIME_TO_EXTENSION: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp',
};

/**
 * Clipboard-pasted images often arrive without a filename extension (e.g. name
 * "image"). Downstream validation keys off extensions, so normalize to a
 * stable, upload-friendly name before the file enters the attach pipeline.
 */
export const normalizePastedFile = (file: File): File => {
  const lastDotIndex = file.name.lastIndexOf('.');
  const hasExtension = lastDotIndex > 0;

  if (hasExtension) {
    return file;
  }

  const mimeType = file.type.toLowerCase();
  const extension = PASTED_IMAGE_MIME_TO_EXTENSION[mimeType];

  if (extension) {
    return new File([file], `image.${extension}`, {
      type: file.type,
      lastModified: file.lastModified,
    });
  }

  return file;
};
